export default __webpack_public_path__ + "static/media/teardrop.83532cbb.png";